import React, { useEffect, useState } from "react";
import api from "../../services/api";
import PeopleDirectoryView from "../../components/common/PeopleDirectoryView";

function HrPeoplePg() {
  const [people, setPeople] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const rows = await api.getHrPeople();
      setPeople(Array.isArray(rows) ? rows : []);
    } catch {
      setPeople([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  return (
    <PeopleDirectoryView
      title="People"
      people={people}
      loading={loading}
      onRefresh={load}
      onFetchDetail={(userId) => api.getHrPeopleDetail(userId)}
      viewMode="hr"
    />
  );
}

export default HrPeoplePg;
